import React from 'react';
import Header from '../../components/ui/Header';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ConsultationBooking from './components/ConsultationBooking';
import ContactMethods from './components/ContactMethods';
import FAQ from './components/FAQ';

const ContactPartnershipGateway = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-16 lg:pt-20">
        <ContactHero />
        
        <div id="contact-form">
          <ContactForm />
        </div>
        
        <div id="consultation-booking">
          <ConsultationBooking />
        </div>
        
        <ContactMethods />

        <FAQ />
      </main>
    </div>
  );
};

export default ContactPartnershipGateway;